import { render, staticRenderFns } from "./DevTools.vue?vue&type=template&id=fc732f96"
import script from "./DevTools.vue?vue&type=script&lang=ts"
export * from "./DevTools.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports